import React, {
  useCallback,
  useEffect,
  useMemo,
  useRef,
  useState,
} from 'react';
import { AdminLayout } from 'apps/sigma2-ui/src/components/AdminLayout';
import { AdminTableRow } from 'apps/sigma2-ui/src/components/AdminLayout';
import { LegacyButtonVariant } from 'apps/sigma2-ui/src/components/ui/Buttons';
import { Dialog } from '@headlessui/react';
import { Transition } from '@headlessui/react';
import { Fragment } from 'react';
import { useUser } from 'apps/sigma2-ui/src/state/user';
import { LegacyButton } from 'apps/sigma2-ui/src/components/ui/LegacyButton';
import { S2Typography } from 'apps/sigma2-ui/src/components/ui/Typography';
import { useLanguage } from 'apps/sigma2-ui/src/lib/hooks/useLanguage';
import { AdminBreadcrumbs } from 'apps/sigma2-ui/src/components/ui/AdminBreadcrumbs';
import { CircularProgress } from '@mui/material';
import { InputLabel } from '@mui/material';
import { MenuItem } from '@mui/material';
import { Select } from '@mui/material';
import { Step } from '@mui/material';
import { StepLabel } from '@mui/material';
import { Stepper } from '@mui/material';
import { Stack } from '@mui/material';
import { GridRowId } from '@mui/x-data-grid-pro';
import { PrimaryButtonLightBg } from 'apps/sigma2-ui/src/components/PrimaryButtonLightBg';
import { SecondaryButtonLightBg } from 'apps/sigma2-ui/src/components/SecondaryButtonLightBg';
import { NewColumnsDataGrid } from 'apps/sigma2-ui/src/components/data-generator/NewColumnsDataGrid';
import { CategoricalValueRows } from 'libs/end-to-end/src/data-generator/data-generator-input';
import { DataGeneratorColumnDetails } from 'libs/end-to-end/src/data-generator/data-generator-input';
import { TimeBoundBiasSetFilter } from 'libs/end-to-end/src/data-generator/data-generator-input';
import { TimeBoundBiasSetBiasType } from 'libs/end-to-end/src/data-generator/data-generator-input';
import { TimeBoundBiasSetBiasTypes } from 'libs/end-to-end/src/data-generator/data-generator-input';
import { TimeBoundRelationshipSet } from 'libs/end-to-end/src/data-generator/data-generator-input';
import { DataGeneratorRows } from 'libs/end-to-end/src/data-generator/data-generator-input';
import { DataGeneratorObservationPeriod } from 'libs/end-to-end/src/data-generator/data-generator-input';
import { TimeBoundBiasSet } from 'libs/end-to-end/src/data-generator/data-generator-input';
import { CorrelationHeatmap } from 'apps/sigma2-ui/src/components/data-generator/CorrelationHeatmap';
import { DataGeneratorInput } from 'libs/end-to-end/src/data-generator/data-generator-input';
import { S2DateRangePicker } from 'apps/sigma2-ui/src/components/DateRangePicker';
import { PartialDateRange } from 'libs/end-to-end/src/date-range';
import { useSimpleWritePattern } from 'apps/sigma2-ui/src/lib/hooks/useSimpleWritePattern';
import { getApiBaseUrl } from 'apps/sigma2-ui/src/constants/environment';
import { guardExhaustive } from 'libs/end-to-end/src/generic';
import { waitForMs } from 'libs/end-to-end/src/generic';
import { useAsyncCallback } from 'apps/sigma2-ui/src/lib/hooks/useAsyncCallback';
import { DataGeneratorRun } from 'libs/end-to-end/src/types/data-generator/data-generator-types';
import { DataGeneratorRuns } from 'libs/end-to-end/src/types/data-generator/data-generator-types';
import { IsAliveFn } from 'apps/sigma2-ui/src/lib/hooks/useAlive';
import { safeParseInt } from 'libs/end-to-end/src/math';
import { formatDateToYYYYMMDD } from 'libs/end-to-end/src/filters-v2/filter-utils';
import { TextFieldCompat } from 'apps/sigma2-ui/src/components/MuiCompat';
import { useSimpleReadPattern } from 'apps/sigma2-ui/src/lib/hooks/useSimpleReadPattern';
import { AdminTable } from 'apps/sigma2-ui/src/components/AdminLayout';
import { Spacing } from 'apps/sigma2-ui/src/components/ui/Spacing';
import { Button } from 'apps/sigma2-ui/src/components/ui/Button';
import { convertTranslatedContentToReactNode } from 'apps/sigma2-ui/src/lib/hooks/useTranslation';
import { useParams } from 'react-router';
import { parseISO } from 'date-fns';
import { tryParseISO } from 'libs/end-to-end/src/dates';
import { Card } from 'apps/sigma2-ui/src/components/ui/Card';
import { AreYouSureDialog } from 'apps/sigma2-ui/src/components/AreYouSureDialog';
import { SelectBoxWithSearch } from 'apps/sigma2-ui/src/components/ui/SelectBoxWithSearch';
import { z } from 'zod';
import { HorizontalFilterBarItem } from 'apps/sigma2-ui/src/filters-v2/components/HorizontalFilterBar';
import { SecondaryFilterButton } from 'apps/sigma2-ui/src/filters-v2/components/SecondaryFilterButton';
import { FilterMenuDualPanel } from 'apps/sigma2-ui/src/filters-v2/components/FilterMenuDualPanel';
import { SearchableFilterListBox } from 'apps/sigma2-ui/src/filters-v2/components/SearchableFilterListBox';

const defaultColumnDetails: DataGeneratorColumnDetails[] = [
  {
    name: 'location',
    description: 'The location control variable',
    dataType: 'categorical',
    dataClass: 'controlVariable',
    values: ['US', 'China'],
    varyAcrossObservations: false,
    varyAcrossPeriods: false,
  },
  {
    name: 'hire',
    description: 'The hire control variable',
    dataType: 'categorical',
    dataClass: 'controlVariable',
    values: ['0', '1'],
    varyAcrossObservations: false,
    varyAcrossPeriods: false,
  },
  {
    name: 'promotion',
    description: 'The promotion control variable',
    dataType: 'categorical',
    dataClass: 'controlVariable',
    values: ['0', '1'],
    varyAcrossObservations: false,
    varyAcrossPeriods: false,
  },
  {
    name: 'attrition',
    description: 'The attrition control variable',
    dataType: 'categorical',
    dataClass: 'controlVariable',
    values: ['0', '1'],
    varyAcrossObservations: false,
    varyAcrossPeriods: false,
  },
  {
    name: 'job_title',
    description: 'Job title',
    dataType: 'categorical',
    dataClass: 'none',
    values: ['Manager', 'Engineer'],
    varyAcrossObservations: false,
    varyAcrossPeriods: false,
  },
  {
    name: 'experience',
    description: 'Experience control variable',
    dataType: 'numerical',
    dataClass: 'controlVariable',
    min: 0,
    max: 5,
    varyAcrossObservations: false,
    varyAcrossPeriods: false,
  },
  {
    name: 'job_level',
    description: 'Job level',
    dataType: 'categorical',
    dataClass: 'none',
    values: ['1', '2', '3', '4', '5'],
    varyAcrossObservations: false,
    varyAcrossPeriods: false,
  },
  {
    name: 'department',
    description: 'Department',
    dataType: 'categorical',
    dataClass: 'none',
    values: ['Management', 'Engineering', 'AI'],
    varyAcrossObservations: false,
    varyAcrossPeriods: false,
  },
];

export const DataGeneratorSteps = [
  'Basic Info',
  'Define Columns',
  'Tune',
  'Bias',
  'Finish',
  'View Results',
] as const;

export const DataGeneratorStepsSchema = z.enum(DataGeneratorSteps);
export type DataGeneratorSteps = z.infer<typeof DataGeneratorStepsSchema>;

export const DataGeneratorPage = () => {
  const language = useLanguage();
  const { userAuthenticatedApiCall } = useUser();
  const [isRunning, setIsRunning] = useState<boolean>(false);
  const [consoleUrl, setConsoleUrl] = useState<string>('');
  const [errorMessage, setErrorMessage] = useState<string | null>(null);
  const [activeStep, setActiveStep] =
    useState<DataGeneratorSteps>('Basic Info');

  const { runId } = useParams();

  const loadByRunIdGetUrlFn = useCallback(() => {
    if (!runId) {
      return '';
    }
    return `${getApiBaseUrl()}/data-generator/runs/${runId}`;
  }, [runId]);

  const loadByRunIdPattern = useSimpleReadPattern({
    getUrlFn: loadByRunIdGetUrlFn,
    canRead: !!runId,
    responseSchema: DataGeneratorRun,
  });

  const isLoading = useMemo(() => {
    if (!runId) {
      return false;
    }

    return loadByRunIdPattern.status === 'loading';
  }, [loadByRunIdPattern.status, runId]);

  const isFailed = useMemo(() => {
    if (!runId) {
      return false;
    }

    return loadByRunIdPattern.status === 'error';
  }, [loadByRunIdPattern.status, runId]);

  // On page load, if the run ID is populated let's load.
  const initializeFromLoadedRun = useCallback((loadedRun: DataGeneratorRun) => {
    if (!loadedRun) {
      return;
    }

    setName(loadedRun.config.name);
    setDescription(loadedRun.config.description);
    setRandomSeed(loadedRun.config.randomSeed || '');
    setRows(
      loadedRun.config.columns.map((col, i) => ({
        id: i,
        name: col.name,
        description: col.description,
        model: col,
      })),
    );
    setRelationshipSets(
      loadedRun.config.relationshipSets &&
        loadedRun.config.relationshipSets.length > 0
        ? loadedRun.config.relationshipSets
        : [
            {
              startDate: loadedRun.config.specialColumnsConfig.startDate,
              endDate: loadedRun.config.specialColumnsConfig.endDate,
              relationships: loadedRun.config.relationships ?? [],
            },
          ],
    );
    setBiasSets(loadedRun.config.biasSets ?? []);
    setSubjectCount(
      loadedRun.config.specialColumnsConfig.subjectCount.toString(),
    );
    setDateRange({
      start: parseISO(loadedRun.config.specialColumnsConfig.startDate),
      end: parseISO(loadedRun.config.specialColumnsConfig.endDate),
    });
    setObservationPeriod(
      loadedRun.config.specialColumnsConfig.observationPeriod ?? 'year',
    );
    setNumberOfObservationsPerPeriodPerSubject(
      loadedRun.config.specialColumnsConfig
        .numberOfObservationsPerSubjectPerPeriod
        ? loadedRun.config.specialColumnsConfig.numberOfObservationsPerSubjectPerPeriod.toString()
        : '',
    );
    setMaxNumberOfSubjectsManaged(
      loadedRun.config.specialColumnsConfig.maxNumberOfSubjectsManaged
        ? loadedRun.config.specialColumnsConfig.maxNumberOfSubjectsManaged.toString()
        : '',
    );
  }, []);

  const loadedRunIdRef = useRef<string | null>(null);
  useEffect(() => {
    if (
      loadByRunIdPattern.status === 'done' &&
      runId &&
      (!loadedRunIdRef.current || loadedRunIdRef.current !== runId)
    ) {
      loadedRunIdRef.current = runId;
      initializeFromLoadedRun(loadByRunIdPattern.entity);
    }
  }, [loadByRunIdPattern, runId, initializeFromLoadedRun]);

  const [rows, setRows] = useState<DataGeneratorRows>(
    defaultColumnDetails.map((d, i) => ({
      id: i,
      name: d.name,
      description: d.description,
      model: d,
    })),
  );

  const [categoricalValueRows, setCategoricalValueRows] =
    useState<CategoricalValueRows>([{ id: 0, value: 'Default' }]);

  const [name, setName] = useState('');
  const [description, setDescription] = useState('');
  const [randomSeed, setRandomSeed] = useState('');
  const [subjectCount, setSubjectCount] = useState('');
  const [dateRange, setDateRange] = useState<PartialDateRange>();
  const [observationPeriod, setObservationPeriod] = useState('year');
  const [
    numberOfObservationsPerPeriodPerSubject,
    setNumberOfObservationsPerPeriodPerSubject,
  ] = useState('1');
  const [maxNumberOfSubjectsManaged, setMaxNumberOfSubjectsManaged] =
    useState('-1');
  const [relationshipSets, setRelationshipSets] = useState<
    TimeBoundRelationshipSet[]
  >([]);
  const [biasSets, setBiasSets] = useState<TimeBoundBiasSet[]>([]);
  const [
    pendingDeleteRelationshipSetIndex,
    setPendingDeleteRelationshipSetIndex,
  ] = useState<number | null>(null);

  const [pendingDeleteBiasSetIndex, setPendingDeleteBiasSetIndex] = useState<
    number | null
  >(null);

  const createRunGetUrlFn = useCallback(() => {
    return `${getApiBaseUrl()}/data-generator/runs`;
  }, []);

  const createRunHook = useSimpleWritePattern({
    getUrlFn: createRunGetUrlFn,
    writeSchema: DataGeneratorInput,
    method: 'POST',
    canWrite: true,
    responseSchema: DataGeneratorRun,
  });

  const pollForRunUpdates = useAsyncCallback(
    async (isAlive: IsAliveFn, newRunId: string) => {
      try {
        let isFirstPoll = true;

        while (isAlive()) {
          await waitForMs(isFirstPoll ? 500 : 3000);
          isFirstPoll = false;

          const getStatusResult = await userAuthenticatedApiCall({
            url: `${getApiBaseUrl()}/data-generator/runs/${newRunId}`,
            requestOptions: {
              method: 'GET',
            },
            responseSchema: DataGeneratorRun,
          });

          if (!getStatusResult || getStatusResult.resultType === 'err') {
            setErrorMessage('Failed to get execution status');
            setIsRunning(false);
            return;
          }
          const result = getStatusResult.value;

          if (result.status === 'success' || result.status === 'fail') {
            setIsRunning(false);
            setConsoleUrl(result.outputConsoleUrl || '');
            if (result.status === 'success') {
              setActiveStep('View Results');
            }
            setErrorMessage(
              result.status === 'fail' ? 'Unable to generate data' : null,
            );
            return;
          } else if (result.status === 'running') {
            continue;
          }

          throw guardExhaustive(result.status);
        }
      } finally {
        setIsRunning(false);
      }
    },
    [userAuthenticatedApiCall],
  );

  const createRun = useCallback(() => {
    const subjectCountParsed = safeParseInt(subjectCount, 10);
    if (subjectCountParsed === null) {
      setErrorMessage('Invalid subject count');
      return;
    }

    if (!dateRange?.start || !dateRange.end) {
      setErrorMessage('Invalid date range');
      return;
    }

    const observationPeriodParsed =
      DataGeneratorObservationPeriod.safeParse(observationPeriod);
    if (!observationPeriodParsed.success) {
      setErrorMessage('Invalid observation period');
      return;
    }

    const numberOfObservationsPerSubjectPerPeriodParsed =
      numberOfObservationsPerPeriodPerSubject.trim().length > 0
        ? safeParseInt(numberOfObservationsPerPeriodPerSubject, 10)
        : null;

    const maxNumberOfSubjectsManagedParsed =
      maxNumberOfSubjectsManaged.trim().length > 0
        ? safeParseInt(maxNumberOfSubjectsManaged, 10)
        : null;

    if (relationshipSets.length === 0) {
      setErrorMessage('No relationships defined');
      return;
    }

    setActiveStep('Finish');

    const config: DataGeneratorInput = {
      name,
      description,
      randomSeed: randomSeed.trim().length === 0 ? null : randomSeed.trim(),
      columns: rows.map((r) => r.model),
      relationshipSets,
      biasSets,
      specialColumnsConfig: {
        subjectCount: subjectCountParsed,
        startDate: formatDateToYYYYMMDD(dateRange.start),
        endDate: formatDateToYYYYMMDD(dateRange.end),
        observationPeriod: observationPeriodParsed.data,
        numberOfObservationsPerSubjectPerPeriod:
          numberOfObservationsPerSubjectPerPeriodParsed,
        maxNumberOfSubjectsManaged: maxNumberOfSubjectsManagedParsed,
      },
    };

    if (createRunHook.status === 'saving') {
      return;
    }

    setIsRunning(true);

    createRunHook.saveEntity(
      config,
      (run) => {
        pollForRunUpdates(run.runId);
      },
      (e) => {
        setErrorMessage(JSON.stringify(e));
        setIsRunning(false);
      },
    );
  }, [
    relationshipSets,
    biasSets,
    createRunHook,
    dateRange?.end,
    dateRange?.start,
    description,
    maxNumberOfSubjectsManaged,
    name,
    numberOfObservationsPerPeriodPerSubject,
    observationPeriod,
    pollForRunUpdates,
    randomSeed,
    rows,
    subjectCount,
  ]);

  const handleNext = useCallback(() => {
    const stepIndex = DataGeneratorSteps.findIndex((s) => s === activeStep);
    if (stepIndex < DataGeneratorSteps.length - 1) {
      setActiveStep(DataGeneratorSteps[stepIndex + 1]);
    }
  }, [activeStep]);

  const handleBack = useCallback(() => {
    const stepIndex = DataGeneratorSteps.findIndex((s) => s === activeStep);
    if (stepIndex > 0) {
      setActiveStep(DataGeneratorSteps[stepIndex - 1]);
    }
  }, [activeStep]);

  const handleAddColumn = useCallback(
    (column: DataGeneratorColumnDetails) => {
      const nextId =
        rows.length === 0
          ? 0
          : Math.max(...rows.map((r) => Number(r.id) || 0)) + 1;
      setRows((prev) => [
        ...prev,
        {
          id: nextId,
          name: column.name,
          description: column.description,
          model: column,
        },
      ]);
    },
    [rows],
  );

  const handleUpdateColumn = useCallback(
    (id: GridRowId, column: DataGeneratorColumnDetails) => {
      setRows((prev) =>
        prev.map((row) =>
          row.id === id
            ? {
                ...row,
                name: column.name,
                description: column.description,
                model: column,
              }
            : row,
        ),
      );
    },
    [setRows],
  );

  const handleNameChanged = useCallback(
    (event: React.ChangeEvent<HTMLInputElement>) => {
      setName((event.target as HTMLInputElement).value);
    },
    [setName],
  );

  const handleDescriptionChanged = useCallback(
    (event: React.ChangeEvent<HTMLInputElement>) => {
      setDescription((event.target as HTMLInputElement).value);
    },
    [setDescription],
  );

  const handleRandomSeedChanged = useCallback(
    (event: React.ChangeEvent<HTMLInputElement>) => {
      setRandomSeed((event.target as HTMLInputElement).value);
    },
    [setRandomSeed],
  );

  const handleSubjectCountChanged = useCallback(
    (event: React.ChangeEvent<HTMLInputElement>) => {
      setSubjectCount((event.target as HTMLInputElement).value);
    },
    [setSubjectCount],
  );

  const handleObservationPeriodChanged = useCallback(
    (event: React.ChangeEvent<HTMLInputElement>) => {
      setObservationPeriod((event.target as HTMLInputElement).value);
    },
    [setObservationPeriod],
  );

  const handleNumberOfObservationsPerPeriodPerSubjectChanged = useCallback(
    (event: React.ChangeEvent<HTMLInputElement>) => {
      setNumberOfObservationsPerPeriodPerSubject(
        (event.target as HTMLInputElement).value,
      );
    },
    [setNumberOfObservationsPerPeriodPerSubject],
  );

  const handleMaxNumberOfSubjectsManagedChanged = useCallback(
    (event: React.ChangeEvent<HTMLInputElement>) => {
      setMaxNumberOfSubjectsManaged((event.target as HTMLInputElement).value);
    },
    [setMaxNumberOfSubjectsManaged],
  );

  const uniqueColumns = useMemo(() => {
    return rows.map((r) => r.name);
  }, [rows]);

  const dimensionOptions = useMemo(() => {
    return rows
      .filter((r) => r.model.dataClass === 'dimension')
      .map((r) => r.name);
  }, [rows]);

  const metricOptions = useMemo(() => {
    return rows
      .filter((r) => r.model.dataClass === 'metric')
      .map((r) => r.name);
  }, [rows]);

  const getPossibleDimensionLevelOptionsForBiasSet = useCallback(
    (dimensionName: string): string[] => {
      const column = rows.find((r) => r.name === dimensionName);

      if (!column || column.model.dataType !== 'categorical') {
        return [];
      }

      // return all but the first item since that one is privilaged and can’t be used for biasing
      return column.model.values.slice(1);
    },
    [rows],
  );

  const createRelationshipSet = useCallback(() => {
    setRelationshipSets((prev) => [
      ...prev,
      {
        startDate: '',
        endDate: '',
        relationships: [],
      },
    ]);
  }, []);

  const createBiasSet = useCallback(() => {
    setBiasSets((prev) => [
      ...prev,
      {
        startDate: '',
        endDate: '',
        dimension: '',
        level: '',
        metric: '',
        filters: [],
        biasType: 'generic',
      },
    ]);
  }, []);

  const getSelectedValuesFromBiasSet = useCallback(
    (biasSet: TimeBoundBiasSet) => {
      const selectedDimension = dimensionOptions.includes(biasSet.dimension)
        ? biasSet.dimension
        : '';

      const dimensionLevelOptions =
        getPossibleDimensionLevelOptionsForBiasSet(selectedDimension);

      const selectedDimensionLevel = dimensionLevelOptions.includes(
        biasSet.level,
      )
        ? biasSet.level
        : '';

      const selectedMetric = metricOptions.includes(biasSet.metric)
        ? biasSet.metric
        : '';

      return {
        selectedDimension,
        selectedDimensionLevel,
        selectedMetric,
        dimensionLevelOptions,
      };
    },
    [
      dimensionOptions,
      getPossibleDimensionLevelOptionsForBiasSet,
      metricOptions,
    ],
  );

  const [stagingFilters, setStagingFilters] = useState<
    TimeBoundBiasSetFilter[]
  >([]);

  const [selectedFilterKey, setSelectedFilterKey] = useState<string>('');

  const [openedFiltersBiasSetIndex, setOpenedFiltersBiasSetIndex] = useState<
    number | null
  >(null);

  const filterKeys = useMemo(() => {
    const keys = new Set<string>();
    for (const row of rows) {
      if (
        row.model.dataClass !== 'dimension' &&
        row.model.dataType === 'categorical'
      ) {
        keys.add(row.name);
      }
    }

    return Array.from(keys);
  }, [rows]);

  const getFilterPossibleValues = useCallback(
    (filterKey: string): string[] => {
      const column = rows.find((r) => r.name === filterKey);
      if (!column || column.model.dataType !== 'categorical') {
        return [];
      }
      return column.model.values;
    },
    [rows],
  );

  const validationError = useMemo(() => {
    if (activeStep === 'Basic Info') {
      const isValid = Boolean(
        name.trim().length > 0 &&
          description.trim().length > 0 &&
          subjectCount.trim().length > 0 &&
          dateRange?.start &&
          dateRange?.end,
      );
      return isValid ? null : 'Please fill out all required fields';
    } else if (activeStep === 'Define Columns') {
      const rowNameSet = new Set(rows.map((r) => r.name));
      const isValid = defaultColumnDetails.every((d) => rowNameSet.has(d.name));
      return isValid
        ? null
        : 'Please include all default columns in the Define Columns step';
    } else if (activeStep === 'Tune') {
      const startDate = dateRange?.start;
      const endDate = dateRange?.end;

      if (!startDate || !endDate) {
        return 'Invalid date range';
      }

      // Validation: relationshipSets must fully cover [startDate, endDate] with no gaps/overlaps,
      // treating endDate as INCLUSIVE (so 2022-12-31 followed by 2023-01-01 is contiguous).
      if (!relationshipSets || relationshipSets.length === 0) {
        return 'No relationship sets defined';
      }

      const toDayKey = (d: Date): number => {
        // Normalize to UTC midnight so local timezone/DST can’t skew day math
        return Date.UTC(d.getUTCFullYear(), d.getUTCMonth(), d.getUTCDate());
      };

      const parseDayKey = (raw: string): number | null => {
        if (!raw || raw.trim().length === 0) {
          return null;
        }
        // Force interpretation as a date-only value at UTC midnight
        const parsed = parseISO(raw);
        if (Number.isNaN(parsed.getTime())) {
          return null;
        }
        return toDayKey(parsed);
      };

      const fmt = (dayKey: number): string => {
        const d = new Date(dayKey); // dayKey is UTC midnight
        const y = d.getUTCFullYear();
        const m = String(d.getUTCMonth() + 1).padStart(2, '0');
        const day = String(d.getUTCDate()).padStart(2, '0');
        return `${y}-${m}-${day}`;
      };

      const overallStartKey = toDayKey(startDate);
      const overallEndKey = toDayKey(endDate);

      if (overallStartKey > overallEndKey) {
        return `Invalid date range: ${formatDateToYYYYMMDD(
          startDate,
        )} must be on/before ${formatDateToYYYYMMDD(endDate)}`;
      }

      type Period = { startKey: number; endKey: number; idx: number };

      const periods: Period[] = [];
      for (let i = 0; i < relationshipSets.length; i++) {
        const rs = relationshipSets[i];
        const sKey = parseDayKey(rs.startDate);
        const eKey = parseDayKey(rs.endDate);

        if (sKey === null) {
          return `Relationship set ${i + 1}: startDate is missing/invalid`;
        }
        if (eKey === null) {
          return `Relationship set ${i + 1}: endDate is missing/invalid`;
        }

        // Inclusive endDate: start must be <= end
        if (sKey > eKey) {
          return `Relationship set ${i + 1}: startDate (${rs.startDate}) must be on/before endDate (${rs.endDate})`;
        }

        periods.push({ startKey: sKey, endKey: eKey, idx: i });
      }

      periods.sort((a, b) => a.startKey - b.startKey);

      if (periods[0].startKey !== overallStartKey) {
        return `First relationship set must start at ${formatDateToYYYYMMDD(
          startDate,
        )}, but starts at ${fmt(periods[0].startKey)}`;
      }

      if (periods[periods.length - 1].endKey !== overallEndKey) {
        return `Last relationship set must end at ${formatDateToYYYYMMDD(
          endDate,
        )}, but ends at ${fmt(periods[periods.length - 1].endKey)}`;
      }

      const oneDayMs = 24 * 60 * 60 * 1000;

      for (let j = 0; j < periods.length - 1; j++) {
        const currentEnd = periods[j].endKey;
        const nextStart = periods[j + 1].startKey;

        // Overlap: next starts on/before current end (inclusive end)
        if (nextStart <= currentEnd) {
          return `Overlap detected between relationship sets: ${fmt(
            nextStart,
          )} starts on/before ${fmt(currentEnd)} ends`;
        }

        // Contiguous: nextStart must equal currentEnd + 1 day
        const expectedNextStart = currentEnd + oneDayMs;
        if (nextStart !== expectedNextStart) {
          return `Gap detected between relationship sets: expected next start ${fmt(
            expectedNextStart,
          )}, but got ${fmt(nextStart)} (previous ends ${fmt(currentEnd)})`;
        }
      }

      return null;
    } else if (activeStep === 'Bias') {
      const overallStartDate = dateRange?.start;
      const overallEndDate = dateRange?.end;
      if (!overallStartDate || !overallEndDate) {
        return 'Invalid overall date range';
      }

      // Make sure the biasSets all have valid ranges (optional start and end)
      for (let i = 0; i < biasSets.length; i++) {
        const biasSet = biasSets[i];
        const startDate = biasSet.startDate
          ? tryParseISO(biasSet.startDate)
          : null;
        const endDate = biasSet.endDate ? tryParseISO(biasSet.endDate) : null;

        // return an error if startDate is before the overall start date
        if (startDate && startDate < overallStartDate) {
          return `Bias set ${i + 1}: startDate (${biasSet.startDate}) must be on/after overall start date (${formatDateToYYYYMMDD(overallStartDate)})`;
        }

        if (startDate && startDate > overallEndDate) {
          return `Bias set ${i + 1}: startDate (${biasSet.startDate}) must be on/before overall end date (${formatDateToYYYYMMDD(overallEndDate)})`;
        }

        // return an error if endDate is after the overall end date
        if (endDate && endDate > overallEndDate) {
          return `Bias set ${i + 1}: endDate (${biasSet.endDate}) must be on/before overall end date (${formatDateToYYYYMMDD(overallEndDate)})`;
        }

        const { selectedDimensionLevel, selectedDimension, selectedMetric } =
          getSelectedValuesFromBiasSet(biasSet);

        if (!selectedDimension) {
          return `Bias set ${i + 1}: dimension is required`;
        }

        if (!selectedDimensionLevel) {
          return `Bias set ${i + 1}: level is required`;
        }

        if (!selectedMetric) {
          return `Bias set ${i + 1}: metric is required`;
        }

        // return an error if any of the filters contain invalid columns or values
        for (let j = 0; j < biasSet.filters.length; j++) {
          const filter = biasSet.filters[j];
          if (!filterKeys.includes(filter.column)) {
            return `Bias set ${i + 1}, filter ${j + 1}: column "${filter.column}" is not a valid column`;
          }

          const possibleValues = getFilterPossibleValues(filter.column);
          for (const value of filter.values) {
            if (!possibleValues.includes(value)) {
              return `Bias set ${i + 1}, filter ${j + 1}: value "${value}" is not a valid value for column "${filter.column}"`;
            }
          }
        }
      }

      return null;
    }

    return null;
  }, [
    activeStep,
    name,
    description,
    subjectCount,
    dateRange?.start,
    dateRange?.end,
    rows,
    relationshipSets,
    biasSets,
    getSelectedValuesFromBiasSet,
    filterKeys,
    getFilterPossibleValues,
  ]);

  const resetStagingFilters = useCallback((biasSet: TimeBoundBiasSet) => {
    setStagingFilters(biasSet.filters);
  }, []);

  const handleColumnsRemoved = useCallback(
    (columnNames: string[]) => {
      if (columnNames.length === 0) return;
      const removedSet = new Set(columnNames);
      setRelationshipSets((prev) =>
        prev.map((rs) => ({
          ...rs,
          relationships: rs.relationships.filter(
            (r) => !removedSet.has(r.columnA) && !removedSet.has(r.columnB),
          ),
        })),
      );
    },
    [setRelationshipSets],
  );

  const getFilterSummaryForBiasSet = useCallback(
    (biasSet: TimeBoundBiasSet): string => {
      const filtersWithValues = biasSet.filters.filter(
        (f) => f.values.length > 0,
      );

      if (filtersWithValues.length === 0) {
        return 'No filters';
      }

      return filtersWithValues
        .map((f) => {
          return `${f.column}: ${f.values.join(', ')}`;
        })
        .join('; ');
    },
    [],
  );

  return (
    <AdminLayout currentPage={'DataGenerator'}>
      <AdminBreadcrumbs
        items={[
          { label: 'Home', to: '/admin' },
          { label: 'Data Generator', to: '/data-generator' },
          { label: 'Create', to: '/data-generator/create' },
        ]}
      />
      <S2Typography
        variant="body-6"
        translatedContent={language.dataGeneratorPageSubHeading()}
      />

      <S2Typography
        variant="headline-4"
        translatedContent={language.dataGeneratorPageTitle()}
      />

      {isLoading && <CircularProgress />}
      {isFailed && (
        <S2Typography
          variant="body-6"
          translatedContent={language.unknownError()}
        />
      )}
      {!isLoading && !isFailed && (
        <Stack direction="column" spacing={1}>
          <Stepper
            activeStep={DataGeneratorSteps.findIndex((s) => s === activeStep)}
            sx={{ py: 2 }}
          >
            {DataGeneratorSteps.map((label) => {
              const stepProps: { completed?: boolean } = {};
              const labelProps: {
                optional?: React.ReactNode;
              } = {};

              return (
                <Step key={label} {...stepProps}>
                  <StepLabel {...labelProps}>{label}</StepLabel>
                </Step>
              );
            })}
          </Stepper>
          {activeStep === 'Basic Info' && (
            <Stack direction="column" spacing={1}>
              <TextFieldCompat
                label="Name"
                variant="outlined"
                value={name}
                onChange={handleNameChanged}
                required
              />
              <TextFieldCompat
                label="Description"
                variant="outlined"
                value={description}
                onChange={handleDescriptionChanged}
                multiline
                rows={3}
                required
              />
              <TextFieldCompat
                label="Random Seed"
                variant="outlined"
                helperText="Optional. Used for deterministic generation."
                value={randomSeed}
                onChange={handleRandomSeedChanged}
              />
              <hr />
              <TextFieldCompat
                label="Subject Count"
                variant="outlined"
                helperText=""
                type="number"
                value={subjectCount}
                onChange={handleSubjectCountChanged}
              />
              <S2DateRangePicker
                value={dateRange}
                onChange={setDateRange}
                label={'Date Range'}
                outline={true}
              />
              <InputLabel id="observation-period-label">
                Observation Period
              </InputLabel>
              <Select
                labelId="observation-period-label"
                value={observationPeriod}
                label="Observation Period"
                onChange={handleObservationPeriodChanged}
              >
                {DataGeneratorObservationPeriod.options.map((p) => (
                  <MenuItem key={p} value={p}>
                    {p}
                  </MenuItem>
                ))}
              </Select>
              <TextFieldCompat
                label="Number of Observations Per Period Per Subject"
                variant="outlined"
                helperText=""
                type="number"
                value={numberOfObservationsPerPeriodPerSubject}
                onChange={handleNumberOfObservationsPerPeriodPerSubjectChanged}
              />
              <TextFieldCompat
                label="Max Number of Subjects Managed"
                variant="outlined"
                helperText=""
                type="number"
                value={maxNumberOfSubjectsManaged}
                onChange={handleMaxNumberOfSubjectsManagedChanged}
              />
            </Stack>
          )}
          {activeStep === 'Define Columns' && (
            <NewColumnsDataGrid
              rows={rows}
              setRows={setRows}
              categoricalValueRows={categoricalValueRows}
              setCategoricalValueRows={setCategoricalValueRows}
              isLoading={isRunning}
              setError={setErrorMessage}
              addColumn={handleAddColumn}
              updateColumn={handleUpdateColumn}
              onColumnsRemoved={handleColumnsRemoved}
            />
          )}
          {activeStep === 'Tune' && relationshipSets && (
            <Spacing direction={'vertical'} size={'md'}>
              <Button
                behavior={{
                  type: 'onClick',
                  onClick: () => {
                    createRelationshipSet();
                  },
                }}
              >
                {convertTranslatedContentToReactNode(
                  language.dataGeneratorCreateRelationshipSetLabel(),
                )}
              </Button>
              {pendingDeleteRelationshipSetIndex !== null && (
                <AreYouSureDialog
                  onSure={() => {
                    const index = pendingDeleteRelationshipSetIndex;
                    setRelationshipSets((prev) =>
                      prev.filter((_, i) => i !== index),
                    );
                    setPendingDeleteRelationshipSetIndex(null);
                  }}
                  onCancel={() => {
                    setPendingDeleteRelationshipSetIndex(null);
                  }}
                  bodyTranslatedContent={language.dataGeneratorAreYouSureDeleteRelationshipSet()}
                  disableInputs={false}
                />
              )}
              {relationshipSets.map((relationshipSet, relationshipSetIndex) => {
                return (
                  <Card key={relationshipSetIndex}>
                    <Spacing size={'md'} direction={'vertical'}>
                      <S2Typography
                        variant={'body-5'}
                        translatedContent={language.dataGeneratorRelationshipSetTitle(
                          {
                            num: relationshipSetIndex + 1,
                            count: relationshipSets.length,
                          },
                        )}
                      />
                      <S2DateRangePicker
                        initialValue={{
                          start: tryParseISO(relationshipSet.startDate),
                          end: tryParseISO(relationshipSet.endDate),
                        }}
                        onChange={(newRange) => {
                          setRelationshipSets((prev) =>
                            prev.map((set, i) => {
                              if (i === relationshipSetIndex) {
                                return {
                                  ...set,
                                  startDate: newRange.start
                                    ? formatDateToYYYYMMDD(newRange.start)
                                    : '',
                                  endDate: newRange.end
                                    ? formatDateToYYYYMMDD(newRange.end)
                                    : '',
                                };
                              }
                              return set;
                            }),
                          );
                        }}
                        label={'Date Range'}
                        outline={true}
                      />

                      <CorrelationHeatmap
                        relationships={relationshipSet.relationships}
                        handleOnChange={(newRelationships) => {
                          setRelationshipSets((prev) =>
                            prev.map((set, i) => {
                              if (i === relationshipSetIndex) {
                                return {
                                  ...set,
                                  relationships: newRelationships,
                                };
                              }
                              return set;
                            }),
                          );
                        }}
                        uniqueColumns={uniqueColumns}
                      />

                      <Button
                        variant={'destructive'}
                        behavior={{
                          type: 'onClick',
                          onClick: () => {
                            setPendingDeleteRelationshipSetIndex(
                              relationshipSetIndex,
                            );
                          },
                        }}
                      >
                        {convertTranslatedContentToReactNode(
                          language.dataGeneratorDeleteRelationshipSetLabel(),
                        )}
                      </Button>
                    </Spacing>
                  </Card>
                );
              })}
            </Spacing>
          )}
          {activeStep === 'Bias' && biasSets && (
            <Spacing direction={'vertical'} size={'md'}>
              <Button
                behavior={{
                  type: 'onClick',
                  onClick: () => {
                    createBiasSet();
                  },
                }}
              >
                {convertTranslatedContentToReactNode(
                  language.dataGeneratorCreateBiasSetLabel(),
                )}
              </Button>
              {pendingDeleteBiasSetIndex !== null && (
                <AreYouSureDialog
                  onSure={() => {
                    const index = pendingDeleteBiasSetIndex;
                    setBiasSets((prev) => prev.filter((_, i) => i !== index));
                    setPendingDeleteBiasSetIndex(null);
                  }}
                  onCancel={() => {
                    setPendingDeleteBiasSetIndex(null);
                  }}
                  bodyTranslatedContent={language.dataGeneratorAreYouSureDeleteBiasSet()}
                  disableInputs={false}
                />
              )}
              {biasSets.map((biasSet, biasSetIndex) => {
                const {
                  selectedDimensionLevel,
                  selectedDimension,
                  selectedMetric,
                  dimensionLevelOptions,
                } = getSelectedValuesFromBiasSet(biasSet);

                return (
                  <Card key={biasSetIndex}>
                    <Spacing size={'md'} direction={'vertical'}>
                      <S2Typography
                        variant={'body-5'}
                        translatedContent={language.dataGeneratorBiasSetTitle({
                          num: biasSetIndex + 1,
                          count: biasSets.length,
                        })}
                      />
                      <Spacing size={'md'} direction={'horizontal'}>
                        <SelectBoxWithSearch
                          type={'single'}
                          setSelected={(newMetricName: string) => {
                            setBiasSets((prev) =>
                              prev.map((set, i) => {
                                if (i === biasSetIndex) {
                                  return {
                                    ...set,
                                    metric: newMetricName,
                                  };
                                }
                                return set;
                              }),
                            );
                          }}
                          selected={selectedMetric}
                          list={metricOptions.map((metricName) => {
                            return {
                              optionLabel: metricName,
                              optionValue: metricName,
                            };
                          })}
                          label={'Metric'}
                          disabled={false}
                        />

                        <S2DateRangePicker
                          initialValue={{
                            start: tryParseISO(biasSet.startDate),
                            end: tryParseISO(biasSet.endDate),
                          }}
                          onChange={(newRange) => {
                            setBiasSets((prev) =>
                              prev.map((set, i) => {
                                if (i === biasSetIndex) {
                                  return {
                                    ...set,
                                    startDate: newRange.start
                                      ? formatDateToYYYYMMDD(newRange.start)
                                      : '',
                                    endDate: newRange.end
                                      ? formatDateToYYYYMMDD(newRange.end)
                                      : '',
                                  };
                                }
                                return set;
                              }),
                            );
                          }}
                          label={'Date Range'}
                          outline={true}
                        />

                        <SelectBoxWithSearch
                          type={'single'}
                          setSelected={(
                            newBiasType: TimeBoundBiasSetBiasType,
                          ) => {
                            setBiasSets((prev) =>
                              prev.map((set, i) => {
                                if (i === biasSetIndex) {
                                  return {
                                    ...set,
                                    biasType: newBiasType,
                                  };
                                }
                                return set;
                              }),
                            );
                          }}
                          selected={biasSet.biasType}
                          list={TimeBoundBiasSetBiasTypes.map((biasType) => {
                            return {
                              optionLabel: biasType,
                              optionValue: biasType,
                            };
                          })}
                          label={'Bias Type'}
                          disabled={false}
                        />

                        <SelectBoxWithSearch
                          type={'single'}
                          setSelected={(newDimension: string) => {
                            setBiasSets((prev) =>
                              prev.map((set, i) => {
                                if (i === biasSetIndex) {
                                  return {
                                    ...set,
                                    dimension: newDimension,
                                  };
                                }
                                return set;
                              }),
                            );
                          }}
                          selected={selectedDimension}
                          list={dimensionOptions.map((dimensionName) => {
                            return {
                              optionLabel: dimensionName,
                              optionValue: dimensionName,
                            };
                          })}
                          label={'Dimension'}
                          disabled={false}
                        />

                        {selectedDimension && (
                          <SelectBoxWithSearch
                            type={'single'}
                            setSelected={(newLevel: string) => {
                              setBiasSets((prev) =>
                                prev.map((set, i) => {
                                  if (i === biasSetIndex) {
                                    return {
                                      ...set,
                                      level: newLevel,
                                    };
                                  }
                                  return set;
                                }),
                              );
                            }}
                            selected={selectedDimensionLevel}
                            list={dimensionLevelOptions.map(
                              (dimensionLevel) => {
                                return {
                                  optionLabel: dimensionLevel,
                                  optionValue: dimensionLevel,
                                };
                              },
                            )}
                            label={'Dimension Level'}
                            disabled={false}
                          />
                        )}

                        {filterKeys.length !== 0 && (
                          <HorizontalFilterBarItem
                            menu={({ closeMenu }) => {
                              return (
                                <FilterMenuDualPanel
                                  items={filterKeys.map((filterKey) => {
                                    return {
                                      key: filterKey,
                                      translatedContent: filterKey,
                                      onClick: () => {
                                        setSelectedFilterKey(filterKey);
                                      },
                                      selected: selectedFilterKey === filterKey,
                                      itemValue: filterKey,
                                      content: (
                                        <SearchableFilterListBox
                                          disabled={false}
                                          items={getFilterPossibleValues(
                                            filterKey,
                                          ).map((value) => {
                                            const selected =
                                              stagingFilters.some(
                                                (item) =>
                                                  item.column === filterKey &&
                                                  item.values.includes(value),
                                              );

                                            return {
                                              translatedContent:
                                                language.dangerousUserInput({
                                                  value,
                                                }),
                                              value,
                                              selected,
                                            };
                                          })}
                                          multiple={true}
                                          onChange={(newItems) => {
                                            setStagingFilters((prev) => {
                                              const otherFilters = prev.filter(
                                                (f) => f.column !== filterKey,
                                              );

                                              return [
                                                ...otherFilters,
                                                {
                                                  column: filterKey,
                                                  values: newItems,
                                                },
                                              ];
                                            });
                                          }}
                                        />
                                      ),
                                    };
                                  })}
                                  bottomProps={{
                                    onApply: () => {
                                      setBiasSets((prev) =>
                                        prev.map((set, i) => {
                                          if (i === biasSetIndex) {
                                            return {
                                              ...set,
                                              filters: stagingFilters,
                                            };
                                          }

                                          return set;
                                        }),
                                      );

                                      closeMenu();
                                    },
                                    onCancel: () => {
                                      closeMenu();
                                    },
                                    applyDisabled: false,
                                    errorTranslatedContent: null,
                                    appliedCount: stagingFilters.filter(
                                      (f) => f.values.length > 0,
                                    ).length,
                                  }}
                                />
                              );
                            }}
                            content={({ openMenu, menuOpened }) => {
                              return (
                                <SecondaryFilterButton
                                  disabled={false}
                                  active={menuOpened}
                                  translatedContent={'Filters'}
                                  onClick={() => {
                                    resetStagingFilters(biasSet);
                                    setSelectedFilterKey(filterKeys[0]);
                                    openMenu();
                                  }}
                                />
                              );
                            }}
                            key={'filters'}
                            openMenu={() =>
                              setOpenedFiltersBiasSetIndex(biasSetIndex)
                            }
                            closeMenu={() => setOpenedFiltersBiasSetIndex(null)}
                            menuOpened={
                              openedFiltersBiasSetIndex === biasSetIndex
                            }
                          />
                        )}

                        <S2Typography
                          variant={'body-7'}
                          translatedContent={getFilterSummaryForBiasSet(
                            biasSet,
                          )}
                        />
                      </Spacing>

                      <Button
                        variant={'destructive'}
                        behavior={{
                          type: 'onClick',
                          onClick: () => {
                            setPendingDeleteBiasSetIndex(biasSetIndex);
                          },
                        }}
                      >
                        {convertTranslatedContentToReactNode(
                          language.dataGeneratorDeleteBiasSetLabel(),
                        )}
                      </Button>
                    </Spacing>
                  </Card>
                );
              })}
            </Spacing>
          )}
          {activeStep === 'Finish' && isRunning && <CircularProgress />}
          {activeStep === 'View Results' && (
            <p>
              Data available here:{' '}
              <a href={consoleUrl} target="_blank" rel="noreferrer">
                {consoleUrl}
              </a>
            </p>
          )}
          {!!validationError && (
            <S2Typography
              variant={'body-6'}
              textColorVariant={'red-700'}
              translatedContent={validationError}
            />
          )}
          <Stack direction={'row'} spacing={2}>
            <SecondaryButtonLightBg
              disabled={activeStep === 'Basic Info'}
              onClick={handleBack}
              translatedContent={'Back'}
            />
            {(activeStep === 'Basic Info' ||
              activeStep === 'Define Columns' ||
              activeStep === 'Tune') && (
              <PrimaryButtonLightBg
                disabled={!!validationError}
                onClick={handleNext}
                translatedContent={'Next'}
              />
            )}
            {activeStep === 'Bias' && (
              <PrimaryButtonLightBg
                disabled={!!validationError}
                onClick={createRun}
                translatedContent={'Finish'}
              />
            )}
          </Stack>
        </Stack>
      )}

      {/* Error message modal */}
      <Transition appear show={!!errorMessage} as={Fragment}>
        <Dialog
          as="div"
          className="relative z-overlay"
          onClose={() => setErrorMessage(null)}
        >
          <Transition.Child
            as={Fragment}
            enter="ease-out duration-300"
            enterFrom="opacity-0"
            enterTo="opacity-100"
            leave="ease-in duration-200"
            leaveFrom="opacity-100"
            leaveTo="opacity-0"
          >
            <div className="fixed inset-0 bg-black bg-opacity-25" />
          </Transition.Child>

          <div className="fixed inset-0 overflow-y-auto">
            <div className="flex min-h-full items-center justify-center p-4 text-center">
              <Transition.Child
                as={Fragment}
                enter="ease-out duration-300"
                enterFrom="opacity-0 scale-95"
                enterTo="opacity-100 scale-100"
                leave="ease-in duration-200"
                leaveFrom="opacity-100 scale-100"
                leaveTo="opacity-0 scale-95"
              >
                <Dialog.Panel className="w-full max-w-md transform overflow-hidden rounded-2xl bg-white p-6 text-left align-middle shadow-12px transition-all">
                  <Dialog.Title
                    as="h3"
                    className="text-lg font-medium leading-6 text-gray-900"
                  >
                    Error
                  </Dialog.Title>
                  <div className="mt-2">
                    <p className="text-sm text-gray-500">{errorMessage}</p>
                  </div>

                  <div className="mt-4">
                    <LegacyButton
                      variant={LegacyButtonVariant.PRIMARY_LIGHT}
                      onClick={() => setErrorMessage(null)}
                      className="mt-4"
                    >
                      Close
                    </LegacyButton>
                  </div>
                </Dialog.Panel>
              </Transition.Child>
            </div>
          </div>
        </Dialog>
      </Transition>
    </AdminLayout>
  );
};

export const DataGeneratorRunsPage = () => {
  const language = useLanguage();

  const listRunsGetUrlFn = useCallback(() => {
    return `${getApiBaseUrl()}/data-generator/runs`;
  }, []);

  const listRunsHook = useSimpleReadPattern({
    getUrlFn: listRunsGetUrlFn,
    responseSchema: DataGeneratorRuns,
    canRead: true,
  });

  const isLoading = useMemo(() => {
    return listRunsHook.status === 'loading';
  }, [listRunsHook]);

  const isFailed = useMemo(() => {
    return listRunsHook.status === 'error';
  }, [listRunsHook]);

  const rows: AdminTableRow[] = useMemo(() => {
    return listRunsHook.status === 'done'
      ? listRunsHook.entity.runs.map((run) => ({
          key: run.runId,
          columns: [
            {
              columnType: 'text',
              key: 'runId',
              text: run.runId,
            },
            {
              columnType: 'text',
              key: 'name',
              text: run.config.name || '<No Name>',
            },
            {
              columnType: 'text',
              key: 'description',
              text: run.config.description || '<No Description>',
            },
            {
              columnType: 'text',
              key: 'createdAtEpoch',
              text: new Date(run.createdAtEpoch).toLocaleString(),
            },
            {
              columnType: 'custom',
              key: 'runBtn',
              ui: (
                <Spacing direction="vertical" size="md">
                  <Button
                    behavior={{
                      type: 'href',
                      href: `/data-generator/runs/${run.runId}`,
                    }}
                  >
                    {convertTranslatedContentToReactNode(
                      language.dataGeneratorCreateCopyButtonLabel(),
                    )}
                  </Button>
                </Spacing>
              ),
            },
            {
              columnType: 'custom',
              key: 'downloadBtn',
              ui: (
                <Spacing direction="vertical" size="md">
                  {run.outputConsoleUrl && (
                    <a
                      href={run.outputConsoleUrl || '#'}
                      target="_blank"
                      rel="noreferrer"
                      className={'text-blue-600 underline'}
                    >
                      Download in AWS Console
                    </a>
                  )}
                </Spacing>
              ),
            },
          ],
        }))
      : [];
  }, [language, listRunsHook]);

  return (
    <AdminLayout currentPage={'DataGeneratorRuns'}>
      <AdminBreadcrumbs
        items={[
          { label: 'Home', to: '/admin' },
          { label: 'Data Generator', to: '/data-generator' },
        ]}
      />

      <S2Typography
        variant="headline-4"
        translatedContent={language.dataGeneratorPageTitle()}
      />

      {isLoading && <CircularProgress />}
      {isFailed && (
        <S2Typography
          variant="body-6"
          translatedContent={language.unknownError()}
        />
      )}
      {!isLoading && !isFailed && (
        <>
          <Button behavior={{ href: '/data-generator/create', type: 'href' }}>
            {convertTranslatedContentToReactNode(
              language.dataGeneratorCreateNewRunButtonLabel(),
            )}
          </Button>
          <AdminTable
            rows={rows}
            headings={[
              'Run ID',
              'Name',
              'Description',
              'Run At',
              'View / Create',
              'Download Data',
            ]}
          />
        </>
      )}
    </AdminLayout>
  );
};
